import { Button, Form, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { ReactElement, useCallback, useState } from 'react';
import Layout from '~Reports/Layout';
import DatePicker from '~UI/DatePicker';

export default function WarehousesFwt2BlendedMargin(): ReactElement {
    const [ endDate, setEndDate ] = useState<string>(null);
    const [ startDate, setStartDate ] = useState<string>(null);
    const [ errors, setErrors ] = useState<{ dateRange?: string }>({});

    const validateDateRange: () => boolean = useCallback(() => {
        let error: string;

        if (!startDate || !endDate) {
            error = 'Please enter a date range';
        }

        if (dayjs(endDate).diff(startDate, 'day') > 90) {
            error = 'Please enter dates that span 90 days or less';
        }

        setErrors({
            ...errors,
            dateRange: error,
        });

        return !error;
    }, [
        endDate,
        errors,
        startDate,
    ]);

    const onChangeDateRange: (dateRange: [Dayjs, Dayjs]) => void = useCallback((dateRange: [Dayjs, Dayjs]) => {
        setEndDate(dateRange[1].format('YYYY-MM-DD'));
        setStartDate(dateRange[0].format('YYYY-MM-DD'));
    }, []);

    const onClickDownload: () => void = useCallback(() => {
        let valid: boolean = true;

        valid = validateDateRange() && valid;

        if (!valid) {
            return;
        }

        window.open(`${process.env.API_HOST}/warehouse-reports/fwt2-blended-margin?startDate=${startDate}&endDate=${endDate}`, '_blank');
    }, [
        endDate,
        startDate,
        validateDateRange,
    ]);

    return (
        <Layout section='warehouses-fwt2-blended-margin'>
            <Typography.Title level={2}>Warehouses - FWT2 Blended Margin</Typography.Title>
            <Form.Item help={errors.dateRange} className='date-range' label='Date Range' validateStatus={errors.dateRange && 'error'}>
                <DatePicker.RangePicker
                    picker='date'
                    format='DD/MM/YYYY'
                    onBlur={validateDateRange}
                    onChange={onChangeDateRange}
                    value={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
                />
            </Form.Item>
            <Form.Item>
                <Button onClick={onClickDownload} type='primary'>Download</Button>
            </Form.Item>
        </Layout>
    );
}
